import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'
import initExpands from '../components/expands'

export default function initListeMembreContact () {
  const $blocks = document.querySelectorAll('.wp-block-liste-membre-contact')
  $blocks.forEach($block => {
    new ListeMembreContact($block)
  })
}

/**
 * Block liste membre contact
 *
 * @param {HTMLElement} $el HTML Element
 */
class ListeMembreContact {
  constructor (element) {
    this.$el = element
    this.$sliders = this.$el.querySelectorAll('.slider-membre')
    this.swipers = []
    this.lgBreakpoint = 1023
    this.$emailBtns = this.$el.querySelectorAll('.btn-email')
    this.$filter = this.$el.querySelector('.wrapper-filtre')

    if (this.$sliders) {
      window.addEventListener('resize', this.onWindowResize.bind(this))
      this.onWindowResize()
    }

    this.initEmailBtns()
    this.initFilter()
  }

  /**
     * Événement lancé à chaque resize de la fenêtre
     * Détermine s'il faut créer ou détruire le swiper
     */
  onWindowResize () {
    if (this.swipers.length !== 0 && window.innerWidth > this.lgBreakpoint) {
      // Détruit le swiper s'il est déjà créé et qu'on est au dessus du breakpoint lg
      this.destroySwipers()
    } else if (this.swipers.length === 0 && window.innerWidth <= this.lgBreakpoint) {
      // Créé le swiper s'il n'est pas déjà créé et q'uon est au dessous du breakpoint lg
      this.createSwipers()
    }
  }

  /**
     * Création des swipers
     */
  createSwipers () {
    if (this.$sliders) {
      this.$sliders.forEach($slider => {
        this.swiper = new Swiper($slider, {
          modules: [Pagination],
          slidesPerView: 'auto',
          loop: false,
          allowTouchMove: true,
          spaceBetween: 20,
          grabCursor: true,
          pagination: {
            el: $slider.querySelector('.swiper-pagination')
          }
        })
        this.swipers.push(this.swiper)
      })
    }
  }

  /**
     * Destruction des swipers
     */
  destroySwipers () {
    for (let i = 0; i < this.swipers.length; i++) {
      if (this.swipers[i]) {
        this.swipers[i].destroy(true, true)
      }
    }
    this.swipers = []
  }

  /**
     * Bouton afficher email
     */
  initEmailBtns () {
    this.$emailBtns.forEach($btn => {
      $btn.addEventListener('click', () => {
        $btn.classList.add('hidden')
        $btn.nextElementSibling.classList.remove('hidden')
      })
    })
  }

  /**
     * Filtre dropdown
     */
  initFilter () {
    if (this.$filter) {
      const selectBoxOptions = this.$filter.querySelectorAll('.selectbox-option')
      selectBoxOptions.forEach(option => {
        option.addEventListener('click', () => {
          this.checkSelectBoxOptions()
        })
      })
    }
  }

  /**
     * Verification des options du filtre activé ou non et affiche les accordeons en concéquence
     */
  checkSelectBoxOptions () {
    const selectBoxOptions = this.$filter.querySelectorAll('.selectbox-option')
    this.hideAllDropdown()
    let nbOptionChecked = 0
    selectBoxOptions.forEach(option => {
      if (option.classList.contains('selected')) {
        this.showDropdown(option.dataset.value)
        nbOptionChecked++
      }
    })
    if (nbOptionChecked == 0) {
      this.showAllDropdown()
    }
  }

  /**
     * Cacher les dropdown
     */
  hideAllDropdown () {
    const allDropdown = this.$el.querySelectorAll('[data-accordeon-target]')
    allDropdown.forEach(dropdown => {
      dropdown.classList.add('hidden')
      dropdown.classList.remove('open')
      const expandContent = dropdown.querySelector('.expand-content')
      if (expandContent) {
        expandContent.style.maxHeight = ''
        expandContent.style.overflow = 'hidden'
      }
    })
  }

  /**
     * afficher les dropdown
     */
  showAllDropdown () {
    const allDropdown = this.$el.querySelectorAll('[data-accordeon-target]')
    allDropdown.forEach(dropdown => {
      dropdown.classList.remove('hidden')
    })
  }

  /**
   * afficher un dropdown en fonction de son data-accordeon-target
   */
  showDropdown (target) {
    const dropdown = this.$el.querySelector('[data-accordeon-target=' + target + ']')
    if (dropdown) {
      dropdown.classList.remove('hidden')
      dropdown.classList.add('open')
      const expandContent = dropdown.querySelector('.expand-content')
      if (expandContent) {
        expandContent.style.maxHeight = '100%'
        expandContent.style.overflow = 'visible'
      }
    }
  }
}
